import { createTheme } from "@mui/material/styles";

/** Retains the original palette and breakpoints. */
export function createPanelTheme(dark) {
  return createTheme({
    palette: {
      mode: dark ? "dark" : "light",
      background: {
        default: !dark ? "#f0f2f5" : "#0e102d",
        paper: !dark ? "#fff" : "#1b1c30",
      },
      success: {
        main: dark ? "#10c819" : "#10c819",
      },
      warning: {
        main: dark ? "#ff8800" : "#ff8800",
      },
      error: {
        main: "#f50000",
      },
      primary: {
        main: "#198dff",
      },
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1570,
        xxl: 1637,
      },
    },
  });
}
